/**
 * @file 路由配置
 * @date 2021-06-24
 */

export default [
    {
        path: '/',
        redirect: '/trade/spot/',
    },
    // 场外借贷 - 线上申请
    // 2025-04-23计划下线，跳转到交易站
    {
        path: '/trade/spot/otc-lending/',
        component: () => import('@/views/otcLending'),
        beforeEnter: () => {
            window.location.replace('/trade/spot/');
        },
        meta: {
            ogtitle: 'og_title',
            ogdescription: 'og_description',
        },
    },
    // 场外借贷 - 我的借款申请
    // 2025-04-23计划下线，跳转到交易站
    {
        path: '/trade/spot/my-lending/',
        component: () => import('@/views/otcLending/mine'),
        beforeEnter: () => {
            window.location.replace('/trade/spot/');
        },
        meta: {
            ogtitle: 'og_title',
            ogdescription: 'og_description',
        },
    },
    // 场外借贷 - 线上申请
    // 2025-05-06计划下线，跳转到交易站
    {
        path: '/trade/spot/bindex',
        component: () => import('@/views/bindex/index'),
        beforeEnter: () => {
            window.location.replace('/trade/spot/');
        },
        meta: {
            pre_symbol: true,
            title: 'bi_page_title',
            ogtitle: 'bi_page_title',
            ogdescription: '',
        },
    },
    // 盈亏分析详情页面
    // 2025-04-23计划下线，跳转到交易站
    {
        path: '/trade/spot/profit-analysis',
        alias: '/trade/spot/profit/analysis/',
        component: () => import('@/views/profitAnalysis/index'),
        beforeEnter: () => {
            window.location.replace('/trade/spot/');
        },
        meta: {
            pre_symbol: true,
            title: 'pa_page_title',
            ogtitle: 'pa_page_title',
            ogdescription: 'pa_page_description',
        },
    },
    // 交易大赛
    {
        path: '/trade/spot/contest/:id/',
        component: () => import('@/views/contest'),
        meta: {
            ogtitle: 'og_title',
            ogdescription: 'og_description',
        },
    },
    // 交易大赛-h5
    {
        path: '/trade/spot/contest/m/:id/',
        component: () => import('@/views/contest/h5'),
        meta: {
            layout: 'Mobile',
            ogtitle: 'og_title',
            ogdescription: 'og_description',
        },
    },
    {
        path: '/trade/spot/act/lt-landing-page',
        component: () => import('@/views/ltLanding'),
        meta: {
            ogtitle: 'og_title',
            ogdescription: 'og_description',
            pre_symbol: true,
        },
    },
    // 全仓杠杆vip 2024-07-25下线，跳转到交易站
    {
        path: '/trade/spot/leverage/vip',
        beforeEnter: () => {
            window.location.replace('/trade/spot/');
        },
        component: () => import('@/views/spot/leverage/vip'),
        meta: {
            title: 'leverage_data',
            ogtitle: 'leverage_data',
            ogdescription: 'leverage_data',
            fixed_header: true,
        },
    },
    // 全仓杠杆折算率 2024-07-25下线，跳转到交易站
    {
        path: '/trade/spot/leverage/discount',
        beforeEnter: () => {
            window.location.replace('/trade/spot/');
        },
        component: () => import('@/views/spot/leverage/Discount'),
        meta: {
            ogtitle: 'og_title',
            ogdescription: 'og_description',
            pre_symbol: true,
        },
    },
    // 全仓杠杆 landing page
    {
        path: '/trade/spot/act/leverage-landing-page',
        component: () => import('@/views/leverageLanding'),
        meta: {
            ogtitle: 'og_title',
            ogdescription: 'og_description',
            pre_symbol: true,
        },
    },

    process.env.NODE_ENV !== 'production'
        ? {
            path: '/login/',
            component: () => import('@/views/login'),
        }
        : {},
    {
        path: '/:nofound*',
        component: () => import('@/views/404'),
        meta: {
            layout: 'Mobile',
            title: 'title_404',
        },
    },
];
